<template>
  <div
    class="form-group hier"
    :class="{active: !isDefault}"
  >
    <div
      class="input-group"
    >
      <div class="input-group-prepend">
        <button
          type="button"
          :disabled="optionCountBefore === 0"
          class="btn"
          @click="action('back')"
        >
          <i class="icon icon-only"><icon-chevron-left /></i>
        </button>
      </div>

      <b-form-select
        :ref="'select_'+name"
        v-model="selectvalue"
        :options="optionElements"
        class="form-control"
        :disabled="optionCountAfter+optionCountBefore <= 0"
      />

      <div class="input-group-append">
        <button
          :disabled="optionCountAfter === 0"
          class="btn"
          type="button"
          @click="action('next')"
        >
          <i class="icon icon-only"><icon-chevron-right /></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue';

import IconChevronRight from 'ICON:IconChevronRight';
import IconChevronLeft from 'ICON:IconChevronLeft';

export default {
  name: 'SelectWithActionS',
  components: {
    BFormSelect,
    IconChevronRight,
    IconChevronLeft,
  },
  model: {
    prop: 'fieldValue',
  },
  props: {
    fieldValue: {
      required: true,
      type: [String, Number],
    },
    defaultValue: {
      required: true,
      type: [String, Number],
    },
    name: {
      required: true,
      type: [String],
    },
    // [{val: '1',label:'start'},{ val: '2',label:'Op 1'}, {val:'3',label:'Op 2'}]
    options: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectvalue: {
      get() {
        return this.fieldValue;
      },
      set(newContent) {
        this.setContent(newContent);
      },
    },
    content: {
      get() {
        return this.fieldValue;
      },
      set(newContent) {
        this.$emit('input', newContent);
      },
    },
    optionElements() { // TECL-2148, remove disabled options
      return this.options.filter((itm) => itm.disabled !== 'disabled');
    },
    optionCountAfter() {
      const optns = this.optionElements;
      // find disabled option
      const disabled = optns.indexOf(optns.find((itm) => itm.disabled === 'disabled'));
      // find current option
      const current = optns.indexOf(optns.find((itm) => itm.value === this.content));

      let checkArray = optns;
      if (disabled >= 0) {
        checkArray = checkArray.slice(0, disabled);
      }
      return checkArray.length - current - 1; // return possible nxt indexes or 0 if last
    },
    optionCountBefore() {
      // get the option with 'this.content', return index to decide first or last option
      return this.itemIndexOf(this.content);
    },

    isDefault() {
      return this.content === this.defaultValue;
    },
  },
  watch: {
    options() {
      const item = this.options[0];
      if (Array.isArray(this.options) && 'text' in item && 'value' in item) {
        return true;
      }
      // eslint-disable-next-line no-console
      console.error('options malformed', this.options);
      throw new Error({ message: 'options malformed' });
    },
  },
  methods: {
    itemIndexOf(value) {
      const item = this.optionElements.find((option) => (option.value === value));
      return this.optionElements.indexOf(item);
    },
    next() {
      let newValue = '';
      let stopNext = false;
      this.optionElements.forEach((option) => {
        if (stopNext === true) {
          newValue = option.value;
          stopNext = false;
        }
        if (option.value === this.content) {
          stopNext = true;
        }
      });
      this.content = newValue;
    },
    back() {
      let newValue = '';
      let stop = false;
      this.optionElements.forEach((option) => {
        if (option.value === this.content) {
          stop = true;
        }
        if (stop === false) {
          newValue = option.value;
        }
      });
      this.content = newValue;
    },
    action(direction) {
      // eslint-disable-next-line no-console
      let curIndex = this.$refs[`select_${this.name}`].$el.selectedIndex;
      if (direction === 'next') {
        if ((this.optionElements.length - 1) > curIndex) {
          curIndex += 1;
        }
      } else {
        curIndex = Math.max(0, curIndex - 1);
      }
      this.$refs[`select_${this.name}`].$el.selectedIndex = curIndex;
      this.$refs[`select_${this.name}`].$el.dispatchEvent(new Event('change'));
      // this.setContent(this.options[curIndex].value);
      // this.$emit('input', this.$refs[`select_${this.name}`].$el.value);
    },
    setContent(newvalue) {
      this.$emit('input', newvalue);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-filter-mobile {
  margin-bottom: 60px;
}

.form-group {
  .btn {
    border: 1px solid $color_ci_complement;
    background: $color_ci_complement;
    color: #fff;
    padding: 0.3em 0.4em;

    #app:not(.isTouchDevice) &:hover {
      border-color: $color_ci_complement_600;
      background: $color_ci_complement_600;
    }

    &.inactive,
    &:disabled {
      border: 1px solid $color_grey_100;
      background: $color_inactive;
      color: $color_grey_900;

      #app:not(.isTouchDevice) &:hover {
        border: 1px solid $color_grey_100;
        background: $color_inactive;
        color: $color_grey_900;
        cursor: default;
      }
    }
  }

  &.active {
    select {
      color: $color_ci_complement_700;
    }

    .btn {
      &.inactive,
      &:disabled {
        border: 1px solid $color_grey_100;
        background: $color_inactive;
        color: $color_grey_900;
      }
    }

    .form-control {
      border-color: $color_ci_complement;
    }
  }
}

/deep/ .custom-control {
  padding-left: 0;
}

</style>
